<template>
    <VModal @closed="emitClose" name="successNotification" class="notification-modal centered" width="100%" height="auto" :scrollable="true">
      <div class="vm-content">
        <img src="@/assets/notification/ic_notification_success.svg" alt="">
        <h3>
          {{ title }}
        </h3>
        <p v-html="message">
        </p>
        <v-btn type="button" class="button button--primary button--small" @click="dismissDialog">Alles klar</v-btn>
      </div>
    </VModal>
</template>

<script>
    export default {
        name: 'SuccessNotificationModal',
        props: {
            title: {
                type: String,
                default() { return {}; } 
            },
            message: {
                type: String,
                default() { return {}; } 
            }
        },
        methods: {
            dismissDialog() {
                this.$modal.hide('successNotification');
            },
            emitClose() {
                this.$emit('closeModal');
            }
        }
    }
</script>